import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Text } from '../text';
export function makeTypographyComponent(_ref) {
  var hardProps = _ref.hardProps,
    defaultProps = _ref.defaultProps,
    displayName = _ref.displayName;
  var Component = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(Text, _extends({}, props, hardProps, {
      ref: ref
    }));
  });
  Component.displayName = displayName;
  Component.defaultProps = defaultProps;
  return Component;
}